import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import { Button } from "@/components/ui/button";
import api, { apiErr } from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function AdminSupport() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/support").then(({ data }) => setItems(data.tickets)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const close = async (id) => {
    try { await api.patch(`/admin/support/${id}`, { status: "closed" }); toast.success("Talep kapatıldı."); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader title="Destek Talepleri" desc="Merchant destek taleplerini yönetin." />
      {items.length === 0 ? <EmptyState title="Destek talebi yok" /> : (
        <div className="space-y-3">
          {items.map((t) => (
            <Card key={t.id} className="p-4">
              <div className="flex items-center justify-between gap-4">
                <div className="min-w-0">
                  <p className="font-semibold">{t.subject}</p>
                  <p className="text-xs text-muted-foreground">{t.merchant_email} · {formatDate(t.created_at)}</p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${t.status === "open" ? "bg-amber-500/10 text-amber-500" : "bg-muted text-muted-foreground"}`}>{t.status === "open" ? "Açık" : "Kapalı"}</span>
                  {t.status === "open" && <Button size="sm" variant="outline" className="rounded-full" onClick={() => close(t.id)}>Kapat</Button>}
                </div>
              </div>
              <p className="mt-2 text-sm text-muted-foreground">{t.message}</p>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
